"use client";
"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = exports.List = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const ListContext = react_1.default.createContext({
    getOrderedCount: () => 0
});
exports.List = react_1.default.forwardRef((_a, ref) => {
    var { children, size, start = 1, sx, variant: variantInitial } = _a, props = __rest(_a, ["children", "size", "start", "sx", "variant"]);
    const { variant: variantContext } = react_1.default.useContext(ListContext);
    const count = react_1.default.useRef(start - 1);
    const getOrderedCount = () => {
        count.current = count.current + 1;
        return count.current;
    };
    const variant = variantInitial || variantContext || "unordered";
    // Reset the count on every render
    count.current = start - 1;
    const content = (react_1.default.createElement(foundations_1.Box, Object.assign({ as: variant === "unordered" ? "ul" : "ol" }, props, { ref: ref, sx: Object.assign(Object.assign({ fontSize: "inherit", lineHeight: "inherit" }, sx), { display: "grid", gridColumnGap: variant === "unordered-accent" ? 3 : 2, gridTemplateColumns: "auto 1fr", listStyle: "none" }) }),
        react_1.default.createElement(ListContext.Provider, { value: { getOrderedCount, start, variant } }, children)));
    return size ? react_1.default.createElement(foundations_1.Text, { size: size }, content) : content;
});
exports.List.displayName = "List";
exports.ListItem = react_1.default.forwardRef((_a, ref) => {
    var { children, sx } = _a, props = __rest(_a, ["children", "sx"]);
    const { getOrderedCount, variant } = react_1.default.useContext(ListContext);
    const marker = react_1.default.useMemo(() => {
        switch (variant) {
            case "ordered":
                return `${getOrderedCount()}.`;
            case "unordered":
                return "•";
            case "unordered-accent":
                return "◉";
        }
    }, [getOrderedCount, variant]);
    const whitespaceY = {
        marginBlockEnd: sx === null || sx === void 0 ? void 0 : sx.marginBlockEnd,
        marginBlockStart: sx === null || sx === void 0 ? void 0 : sx.marginBlockStart,
        marginBottom: sx === null || sx === void 0 ? void 0 : sx.marginBottom,
        marginTop: sx === null || sx === void 0 ? void 0 : sx.marginTop,
        mb: sx === null || sx === void 0 ? void 0 : sx.mb,
        mt: sx === null || sx === void 0 ? void 0 : sx.mt,
        my: sx === null || sx === void 0 ? void 0 : sx.my,
        paddingBlockEnd: sx === null || sx === void 0 ? void 0 : sx.paddingBlockEnd,
        paddingBlockStart: sx === null || sx === void 0 ? void 0 : sx.paddingBlockStart,
        paddingBottom: sx === null || sx === void 0 ? void 0 : sx.paddingBottom,
        paddingTop: sx === null || sx === void 0 ? void 0 : sx.paddingTop,
        pb: sx === null || sx === void 0 ? void 0 : sx.pb,
        pt: sx === null || sx === void 0 ? void 0 : sx.pt,
        py: sx === null || sx === void 0 ? void 0 : sx.py
    };
    return (react_1.default.createElement(foundations_1.Box, Object.assign({ as: "li" }, props, { ref: ref, sx: Object.assign(Object.assign({ fontSize: "inherit", lineHeight: "inherit" }, sx), { display: "contents" }) }),
        react_1.default.createElement(foundations_1.Box, { as: "span", "aria-hidden": true, sx: Object.assign(Object.assign({}, whitespaceY), { color: variant === "unordered-accent" ? "accent01" : "currentColor", fontSize: "inherit", lineHeight: "inherit", textAlign: "end" }) }, marker),
        react_1.default.createElement(foundations_1.Box, { as: "span", sx: Object.assign(Object.assign({}, whitespaceY), { fontSize: "inherit", lineHeight: "inherit" }) }, children)));
});
exports.ListItem.displayName = "ListItem";
//# sourceMappingURL=List.js.map